// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__X003T","active":"styles_active__7EDRS","inactive":"styles_inactive__Jyxbi"};